import axiosInstance from './axiosConfig'
import { createCancelToken } from './axiosUtils'

const OrderAPI = {
  getAll: function ({ org_id, offset = 0, limit = 10, status }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/orders`,
      params: { limit, offset, status },
    })
  },
  superAdminGetAll: function ({ search, start, end, status, offset = 0, limit = 10 }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/super-admin/orders`,
      params: { limit, offset, search, start, end, status },
    })
  },
  verify: function (order_id) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/orders/${order_id}/verify`,
    })
  },
  reject: function (order_id) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/orders/${order_id}/reject`,
    })
  },
  getById: function (org_id, order_id) {
    return axiosInstance.request({
      method: 'GET',
      url: `/orders/${org_id}/${order_id}`,
    })
  },
  genOrderCode: function (org_id) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/gen-order-code`,
    })
  },
  create: function ({ org_id, ...data }) {
    return axiosInstance.request({
      method: 'POST',
      url: `/organizations/${org_id}/orders`,
      data: data,
    })
  },
  update: function ({ org_id, order_id, ...data }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/orders/${org_id}/${order_id}`,
      data: data,
    })
  },
  delete: function (org_id, order_id) {
    return axiosInstance.request({
      method: 'DELETE',
      url: `/orders/${org_id}/${order_id}`,
    })
  },
  createMomoOrder: function ({ org_id, ...data }) {
    return axiosInstance.request({
      method: 'POST',
      url: `/organizations/${org_id}/payment_momo`,
      data: data,
    })
  },
  createVnpayOrder: function ({ org_id, ...data }) {
    return axiosInstance.request({
      method: 'POST',
      url: `/organizations/${org_id}/payment_vnp`,
      data: data,
    })
  },
}

const cancelTokenObject = createCancelToken(OrderAPI)
export default OrderAPI
